import {
    GET_BA_DATA, GET_BA_DATA_INVOICE,
    LATE_FEE, GET_BA_DATA_INVOICE_BY_SITE,
    GET_CLIENT_ORDERS
  } from './type';

const initalState = {
    dashboardSiteListing: {},
    lateFee: {},
    getClientOrdersListing: {}
  };
  
const BaDashboardReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_BA_DATA:
        return {
          ...state,
          dashboardSiteListing: payload,
        };
      case GET_BA_DATA_INVOICE:
        return {
          ...state,
          dashboardInvoiceListing: payload,
        };
      case LATE_FEE:
        return {
          ...state,
          lateFee: payload,
        };
      case GET_BA_DATA_INVOICE_BY_SITE:
        return {
          ...state,
          dropdownInvoiceListing: payload,
        };  
      case GET_CLIENT_ORDERS:
        return {
          ...state,
          getClientOrdersListing: payload,
        };  
      default:
        return {
          ...state,
        };
    }
  };
  
  export default BaDashboardReducer;